import { Button, Grid, Skeleton, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useTalentFilters } from '../../../Hooks/useTalentFilters';
import { useGetTalentsQuery } from '../../../Redux/api/talentApi';
import { KaziTalentCard } from '../../../Shared Components/Kazi/Cards/KaziTalentCard';
import { Talent } from '../../../Types/Talent';
import { getHasRequiredFields } from '../../../Utils/TalentUtils';
import { TalentSearchFilters } from './TalentSearchFilters';

interface TalentMarketplaceData {
    title: string;
    items: Talent[];
}

export const TalentMarketplace = () => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const { filterTalents, getSpecialization } = useTalentFilters();
    const {data: talents, isLoading: talentsLoading, isFetching: talentsFetching} = useGetTalentsQuery();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const formatTalents = () =>{
        if (talents) {
            let filteredTalents = filterTalents(talents);       
            let specializations = new Set();
            let formattedTalents: TalentMarketplaceData[] = [];
            
            filteredTalents.forEach( talent => {
                if (getHasRequiredFields(talent) ) {
                    const specialization = getSpecialization(talent?.resume?.expertise?.primary_expertise);
                    if (specializations.has(specialization)) {
                        const idx = formattedTalents.findIndex((j: any) => j.title === specialization);
                        formattedTalents[idx].items.push(talent);
                    } else {
                        specializations.add(specialization);
                        formattedTalents.push({title: specialization, items: [talent]});
                    }
                }
            })
            return formattedTalents.sort((a,b) => {
                if (a.title > b.title) return 1;
                if (a.title < b.title) return -1;
                return 0;
            })
        }
        return []
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
        return (
            <>
                {
                    talentsLoading || talentsFetching ?
                    <>
                        <Grid>
                            <Skeleton variant='rectangular' sx={{height: "50px", width: "150px"}} />
                        </Grid>
                        <Grid display={'grid'} gridTemplateColumns={'repeat(3, 388px)'} marginTop={3} columnGap={4}>
                            <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                            <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                            <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                        </Grid>
                        <Grid display={'grid'} gridTemplateColumns={'repeat(3, 388px)'} marginTop={3} columnGap={4}>
                            <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                            <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                            <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                        </Grid>
                    </>:
                    <>
                        <TalentSearchFilters />
                        {formatTalents().map((talent, rowIdx) => (
                            <Grid key={talent.title} width={"100%"} >
                                <Grid display={"flex"} flexDirection={"row"} marginRight={'2%'}>
                                    <Typography variant='lora-headline-small' display={"flex"} flex={1} >{talent.title}</Typography>
                                    {
                                        // talent.items.length > 3 &&
                                        <Button variant='text' onClick={() => navigate(`/marketplace/${talent.title}`)}>
                                            <Typography variant='label-large' fontWeight={"bold"} display={"flex"} flex={1} justifyContent={"flex-end"}>See all</Typography>
                                        </Button>
                                    }
                                </Grid>
                                <Grid display={'grid'} gridTemplateColumns={'repeat(auto-fit, minmax(290px, 308px))'} marginTop={3} columnGap={4} rowGap={4}>
                                    {
                                        talent.items.slice(0, 3).map((item, columnIdx) =>(
                                            <Grid key={`${item.title}-${rowIdx}-${columnIdx}`}>
                                                <KaziTalentCard talent={item} sx={{height: '100%'}}/>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </Grid>
                        ))}
                    </>
                }
            </>
        )
    }